import React from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import AllPatients from "./Patinets/AllPatients";
import VerificationCenters from "./CounterAgents/VerificationCenters/VerificationCenters";
import Medcenters from "./CounterAgents/VerificationCenters/Medcenters";
import Organizations from "./CounterAgents/VerificationCenters/Organizations";
import OrgHistory from "./CounterAgents/VerificationCenters/OrgHistory";
import Organizations_medcenter from "./CounterAgents/Medcenter/Organizations_medcenter";
import OrgHistory_medcenter from "./CounterAgents/Medcenter/OrgHistory_medcenter";
import MedCenters_medcenter from "./CounterAgents/Medcenter/MedCenters_medcenter";
import HistoryPatients from "./CounterAgents/VerificationCenters/HistoryPatients";
import HistoryPatients_medcenter from "./CounterAgents/Medcenter/HistoryPatients_medcenter";
import Organizations_organization from "./CounterAgents/Organization/Organizations_organization";
import OrgHistory_organization from "./CounterAgents/Organization/OrgHistory_organization";
import HistoryPatients_organization from "./CounterAgents/Organization/HistoryPatients_organization";
import All_verificationCenter from "./CounterAgents/All_verificationCenter";
import Calendar from "./Calendar/Calendar";
import VerCanterAllOrganizations from "./CounterAgents/VerificationCenters/VerCanterAllOrganizations";
import VerCanterPrices from "./CounterAgents/VerificationCenters/VerCanterPrices";
import VerCanterDoctors from "./CounterAgents/VerificationCenters/VerCanterDoctors";
import VerCanterDoctorPrices from "./CounterAgents/VerificationCenters/VerCanterDoctorPrices";
import VerCanterMachines from "./CounterAgents/VerificationCenters/VerCanterMachines";
import AddPayment from "./CounterAgents/addPayment";


import AllCabinetSurveysHistory from "./Calendar/CabinetSurveysHistory/AllCabinetSurveysHistory";
import OrganizationCabinetSurveyHistory from "./Calendar/CabinetSurveysHistory/OrganizationCabinetSurveyHistory";
import AllCarSurveysHistory from "./Calendar/CarSurveyHistory/AllCarSurveysHistory";
import OrganizationCarSurveysHistory from "./Calendar/CarSurveyHistory/OrganizationCarSurveysHistory";
import AllCarSurveysHistoryToday from "./Calendar/CarSurveyHistory/AllCarSurveysHistoryToday";
import Roles from "./Activities/Roles";
import {PatientQrResultSwitcher} from "../General/QrResult/QrResult";
import OrgSearch from "../General/OrgSearch";
import {PatientQrResultSwitcher2} from "../General/QrResult2/QrResult2";
import Doctors from "./Doctor/Doctors";
import TestResults from "./Doctor/TestResults";
import Images from "./Doctor/Images";
import ManagerNotifications from "../General/Notificatioins/ManagerNotifications";
import Editing from "./Activities/Editing";
import {PageAnalyticDoctor} from "./Activities/Analytic.doctor";
import {PageAnalyticPlaces} from "./Activities/Analytic.places";
import DiagnosesMismatch2 from "./Doctor/DiagnosesMismatch";
import DiagnosesMismatch from "./Doctor/DiagnosesMismatch";


function VerificationCenterRoutes() {
    const {REACT_APP_URL_PREFIX} = process.env
    return (
        <Switch>
            <Route path={REACT_APP_URL_PREFIX + '/patients/allPatients'} exact><AllPatients/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters'} exact> <VerificationCenters/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/all'}
                   exact> <VerCanterAllOrganizations/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/prices'}
                   exact> <VerCanterPrices/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/doctors'}
                   exact> <VerCanterDoctors/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/doctorprices/:doctorId/:doctorName/prices'}
                   exact> <VerCanterDoctorPrices/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/machines'}
                   exact> <VerCanterMachines/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/addPayment'} exact><AddPayment/></Route>
				   
				   
            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/medCentres'}
                exact> <Medcenters/> </Route>
            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/medCentres/:medId/:medName/organizations'}
                exact><Organizations/> </Route>
            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/medCentres/:medId/:medName/organizations/:orgId/:orgName/history'}
                exact><OrgHistory/> </Route>
            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters/:verCenterId/:verCenterName/medCentres/:medId/:medName/organizations/:orgId/:orgName/history/:historyId/:historyName/patients'}
                exact><HistoryPatients/> </Route>

            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/medCenters'} exact> <MedCenters_medcenter/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/medCenters/:medId/:medName/:verCenterId/organizations'}
                   exact><Organizations_medcenter/></Route>
            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/medCenters/:medId/:medName/:verCenterId/organizations/:orgId/:orgName/history'}
                exact> <OrgHistory_medcenter/> </Route>
            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/medCenters/:medId/:medName/:verCenterId/organizations/:orgId/:orgName/history/:historyId/:historyName/patients'}
                exact> <HistoryPatients_medcenter/> </Route>

            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/organizations'} exact><Organizations_organization/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/organizations/:orgId/:verCenterId/:orgName/history'}
                   exact> <OrgHistory_organization/> </Route>
            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/organizations/:orgId/:verCenterId/history/:historyId/:historyName/patient'}
                exact>
                <HistoryPatients_organization/> </Route>

            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/allOrganizations'} exact> <All_verificationCenter/>
            </Route>


            <Route path={REACT_APP_URL_PREFIX + '/calendar'} exact> <Calendar/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/carSurveysToday'} exact><AllCarSurveysHistoryToday/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/amoId/:amoId'} exact> <Calendar/> </Route>

            <Route path={REACT_APP_URL_PREFIX + '/calendar/organization/:orgId/:orgName'} exact> <Redirect/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/medCenter/:medId/:medName/organization/:orgId/:orgName'}
                   exact> <Calendar/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/:verCenterId/:verCenterName'} exact>
                <Calendar/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/:verCenterId/:verCenterName/organization/:orgId/:orgName'}
                   exact>

                {/*<Calendar_verificationCenter/>*/}
                <Calendar/>

            </Route>
            <Route
                path={REACT_APP_URL_PREFIX + '/calendar/:verCenterId/:verCenterName/medCenter/:medId/:medName/organization/:orgId/:orgName'}
                exact>
                {/*<Calendar_verificationCenter/> */}
                <Calendar/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys'} exact><AllCabinetSurveysHistory/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys/:orgId/:orgName'}
                   exact><OrganizationCabinetSurveyHistory/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/calendar/carSurveys'} exact><AllCarSurveysHistory/></Route>


            <Route path={REACT_APP_URL_PREFIX + '/calendar/carSurveys/:orgId/:orgName'}
                   exact><OrganizationCarSurveysHistory/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/activities/roles'} exact><Roles/></Route>

            <Route path={REACT_APP_URL_PREFIX + '/activities/editing'} component={Editing} exact/>
            <Route path={REACT_APP_URL_PREFIX + '/activities/analytic/doctor'} exact><PageAnalyticDoctor/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/activities/analytic/places'} exact><PageAnalyticPlaces/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/doctors/list'} exact><Doctors/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/doctors/test-results'} exact><TestResults/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/doctors/images'} exact> <Images/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/doctors/diagnoses-mismatch'} exact> <DiagnosesMismatch/></Route>


            <Route path={REACT_APP_URL_PREFIX + "/checkIn"} exact> <PatientQrResultSwitcher/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/checkBlank/:data'} exact> <PatientQrResultSwitcher2/> </Route>

            <Route path={REACT_APP_URL_PREFIX + '/orgSearch'} exact> <OrgSearch/></Route>
            <Route path={REACT_APP_URL_PREFIX + "/notifications"} exact>
                <ManagerNotifications/>
            </Route>
            <Redirect to={`${REACT_APP_URL_PREFIX}/patients/allPatients`}/>

        </Switch>
    );
}

export default VerificationCenterRoutes;